module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 015.ff75d14a.jpg";